export const vhsControlRoomTheme = {
    id: 'vhs-control-room',
    label: 'VHS Control Room',
    description: 'Branded 80s creative. Use for expressive / marketing-adjacent screens.',
    paletteMode: 'dark',
    tokens: {
        app: { bg: '#080D1A', bgElevated: '#10172A' },
        surface: {
            nav: '#080D1A',
            panel: '#17223A',
            panelAlt: '#3B2F5C',
            input: '#111A2E',
        },
        border: {
            default: 'rgba(242, 233, 216, 0.16)',
            strong: 'rgba(39, 230, 214, 0.50)',
        },
        text: {
            primary: '#F2E9D8',
            secondary: '#B8ADBC',
            disabled: '#746D7B',
            inverse: '#031412',
        },
        action: {
            primary: '#27E6D6',
            primaryHover: '#73FFF3',
            secondary: '#FF3F9F',
        },
        state: {
            success: '#27E6D6',
            warning: '#F7A541',
            error: '#F04444',
            info: '#8B5CF6',
        },
        data: {
            seriesA: '#27E6D6',
            seriesB: '#FF3F9F',
            seriesC: '#F2E9D8',
            seriesD: '#F04444',
        },
        effect: {
            glow: 'rgba(255, 63, 159, 0.36)',
            shadow: '0 18px 60px rgba(3, 5, 12, 0.46)',
        },
    },
};
//# sourceMappingURL=vhs-control-room.js.map